import { Observable, pipe, UnaryFunction } from 'rxjs';
import { scan } from 'rxjs/operators';

export interface TDefault {
  id?: string;
  [key: string]: any;
}

export enum TableActions {
  INITIALIZE,
  ADD
}

export interface TableQuery {
  sortBy?: string,
  /** Page number must be bigger then 0 */
  pageNumber: number,
  /** Page limit must be bigger then 0 */
  pageLimit: number,
  payloadCount?: number,
  totalPages?: number
  filters?: string[]
}

export interface TableStreamData<T> {
  action?: keyof typeof TableActions | string;
  payload: T[];
  query?: TableQuery;
}

export function tableReducer<T>(): UnaryFunction<Observable<TableStreamData<T>>, Observable<TableStreamData<T>>> {
  return pipe(
    scan<TableStreamData<T>, TableStreamData<T>>(
      (acc, curr) => {
        const newStream: TableStreamData<T> = {
          action: curr.action,
          ...acc,
          query: { ...acc.query, ...curr.query },
          payload: curr.payload
        };
        return newStream;
      }, {
      action: TableActions[TableActions.INITIALIZE],
      payload: [],
      query: {
        pageNumber: 0,
        pageLimit: 0,
        payloadCount: 0,
        totalPages: 0
      }
    }
    )
  )
}
